import _regeneratorRuntime from 'babel-runtime/regenerator';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody, ButtonToolbar } from 'reactstrap';
import { Card, Table, CardHeader, CardTitle, CardText, CardBody, CardFooter, Row, Col, Container } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { css } from 'emotion';
import { RXBlock, RXBlockStatus, RXBlockColor } from './RXBlock';

var includes = require('lodash/includes');

var logdown = require('logdown');
var console = logdown('rx-core-table', { prefixColor: '#d84315' });

export var RXTableTitle = function RXTableTitle(props) {
    if (props.title) {
        return React.createElement(
            'div',
            { className: "float-left" },
            props.title(props.model.title)
        );
    }

    return React.createElement(
        'div',
        { className: "float-left" },
        props.model.title
    );
};

var ButtonModels = {
    "refresh": function refresh(props) {
        return React.createElement(
            Button,
            {
                key: props.index,
                disabled: props.disabled,
                style: { marginLeft: 10 },
                outline: true,
                size: 'sm',
                color: props.color,
                onClick: props.onClick
            },
            React.createElement('i', { className: 'fa fa-refresh fa-lg text-' + props.color })
        );
    }
};

export var RXTableButtons = function (_Component) {
    _inherits(RXTableButtons, _Component);

    function RXTableButtons(props) {
        var _this2 = this;

        _classCallCheck(this, RXTableButtons);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentDidUpdate = function (prevProps, prevState) {
            if (_this.props.value != prevProps.value) {
                console.log('update values: ' + JSON.stringify(_this.props.value));
                _this.setState({ value: _this.props.value });
            }
        };

        _this.onClick = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, actionColor, actionMessage, refresh) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this.props.tableWillRefresh(actionColor, actionMessage);

                                _context.prev = 1;
                                _context.next = 4;
                                return new Promise(function (resolve, reject) {
                                    action(resolve, reject);
                                });

                            case 4:
                                if (!refresh) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 7;
                                return new Promise(function (resolve, reject) {
                                    _this.props.doRefresh(resolve, reject);
                                });

                            case 7:
                                _this.props.tableDidRefresh(true);
                                _context.next = 14;
                                break;

                            case 10:
                                _context.prev = 10;
                                _context.t0 = _context['catch'](1);

                                console.log('in error with ' + _context.t0);
                                _this.props.tableDidRefresh(false);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[1, 10]]);
            }));

            return function (_x, _x2, _x3, _x4) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.state = {
            value: props.value
        };
        return _this;
    }

    RXTableButtons.prototype.render = function render() {
        var _this3 = this;

        var props = this.props;
        var buttons = props.buttons;

        if (props.buttonsFilter && this.state.value) {
            buttons = [];
            var allowButtons = props.buttonsFilter(props.buttons, this.state.value);

            for (var _iterator = props.buttons, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref2;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref2 = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref2 = _i.value;
                }

                var originalButton = _ref2;

                if (allowButtons.includes(originalButton.value)) {
                    buttons.push(originalButton);
                }
            }
        }

        console.log('buttons: ' + buttons);

        return React.createElement(
            'div',
            { className: "float-right" },
            buttons.map(function (button, index) {

                var action = button.action ? button.action : function () {};
                var color = button.actionColor ? button.actionColor : RXBlockColor.PRIMARY;
                var refresh = button.refresh ? button.refresh : false;
                var message = button.actionMessage ? button.actionMessage : "";
                if (button.type && ButtonModels[button.type]) {
                    var ButtonModel = ButtonModels[button.type];

                    //HACK FOR REFRESH BUTTON
                    if (button.type == "refresh") {
                        // action = props.doRefresh
                        action = function action(resolve, reject) {
                            console.log('IN ACTION FOR REFRESH');
                            resolve();
                        };
                        refresh = true;
                        message = "Refresh";
                    }

                    return React.createElement(ButtonModel, _extends({ disabled: props.disabled, key: index, onClick: function onClick() {
                            return _this3.onClick(action, color, message, refresh);
                        } }, button));
                } else {

                    return React.createElement(
                        Button,
                        { key: index, disabled: props.disabled, style: { marginLeft: 10 }, onClick: function onClick() {
                                return _this3.onClick(action, color, message, refresh);
                            }, outline: button.outline, size: 'sm', color: button.color },
                        button.title
                    );
                }
            })
        );
    };

    return RXTableButtons;
}(Component);

export var RXTableField = function (_Component2) {
    _inherits(RXTableField, _Component2);

    function RXTableField(props) {
        _classCallCheck(this, RXTableField);

        var _this4 = _possibleConstructorReturn(this, _Component2.call(this, props));

        _this4.state = {
            value: _this4.props.value
        };
        return _this4;
    }

    RXTableField.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.value != prevProps.value) {

            console.log('update RXTABLE FIELD values with ' + JSON.stringify(this.props.value));
            this.setState({ value: this.props.value });
        }
    };

    RXTableField.prototype.render = function render() {
        var _this5 = this;

        var props = this.props;

        var getValue = function getValue(name) {
            var value = name.split('.').reduce(function (o, i) {
                return o ? o[i] : o;
            }, _this5.state.value);
            console.log('return value for ' + name + ': ' + value);

            return value;
        };

        var value = getValue(props.field.name);
        if (value !== undefined || props.field.virtual) {
            if (props.formatters[props.field.name]) {
                return React.createElement(
                    'span',
                    null,
                    props.formatters[props.field.name](value, this.state.value)
                );
            } else if (props.typeFormatters[props.field.type]) {
                return React.createElement(
                    'span',
                    null,
                    props.typeFormatters[props.field.type](value, this.state.value)
                );
            } else {
                return React.createElement(
                    'span',
                    null,
                    '' + value
                );
            }
        }

        return React.createElement('span', null);
    };

    return RXTableField;
}(Component);

RXTableField.defaultProps = {
    value: {},
    virtual: false
};

export var RXTablePagination = function RXTablePagination(props) {
    return React.createElement(
        Pagination,
        { 'aria-label': 'Page navigation example', size: 'sm', className: 'float-right', style: { marginBottom: 0 } },
        React.createElement(
            PaginationItem,
            { disabled: true },
            React.createElement(PaginationLink, { previous: true, href: '#' })
        ),
        React.createElement(
            PaginationItem,
            { active: true },
            React.createElement(
                PaginationLink,
                { href: '#' },
                '1'
            )
        ),
        React.createElement(
            PaginationItem,
            null,
            React.createElement(
                PaginationLink,
                { href: '#' },
                '2'
            )
        ),
        React.createElement(
            PaginationItem,
            null,
            React.createElement(
                PaginationLink,
                { href: '#' },
                '3'
            )
        ),
        React.createElement(
            PaginationItem,
            null,
            React.createElement(
                PaginationLink,
                { href: '#' },
                '4'
            )
        ),
        React.createElement(
            PaginationItem,
            null,
            React.createElement(
                PaginationLink,
                { href: '#' },
                '5'
            )
        ),
        React.createElement(
            PaginationItem,
            null,
            React.createElement(PaginationLink, { next: true, href: '#' })
        )
    );
};

export var RXTable = function (_Component3) {
    _inherits(RXTable, _Component3);

    function RXTable() {
        _classCallCheck(this, RXTable);

        return _possibleConstructorReturn(this, _Component3.apply(this, arguments));
    }

    RXTable.prototype.render = function render() {
        return React.createElement(Card, null);
    };

    return RXTable;
}(Component);

RXTable.defaultProps = {
    model: {
        title: "RXTable default"
    }

    // module.exports = {
    //     RXTable: RXTable,
    //     RXTableTitle: RXTableTitle,
    //     RXTableButtons: RXTableButtons,
    //     RXTablePagination: RXTablePagination,
    //     RXTableField: RXTableField
    // }

};